import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Banner from './components/Banner/Banner';
import Body from './components/Body/Body';
import Footer from './components/Footer/Footer';
import CookiePolicy from './components/CookiePolicy/CookiePolicy';

function App() {
  return (
    <BrowserRouter>
      <Header />
      <Banner />
      <Routes>
        <Route path="/" element={<Body />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
